import { render, staticRenderFns } from "./ThirdPartyPage.vue?vue&type=template&id=927c584a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('927c584a')) {
      api.createRecord('927c584a', component.options)
    } else {
      api.reload('927c584a', component.options)
    }
    module.hot.accept("./ThirdPartyPage.vue?vue&type=template&id=927c584a&", function () {
      api.rerender('927c584a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/thirdParty/ThirdPartyPage.vue"
export default component.exports